module.exports = __webpack_public_path__ + "static/media/img-goal-13.df7e254a.jpg";